import { Validator } from '@vista-digital/validator';
export const defaultFilmReleaseDateDisplayText = {
    label: 'Release date',
    format: '${date|d|D MMMM YYYY}'
};
export const filmReleaseDateDisplayTextValidatorSchema = {
    label: Validator.nonEmptyString,
    format: Validator.nonEmptyString
};
export const filmReleaseDateDisplayTextValidator = Validator.object(filmReleaseDateDisplayTextValidatorSchema);
//# sourceMappingURL=display-text.js.map